import React from 'react';
import { CatalogItem } from '../../api/productCatalog';
import CardSection from './CardSection';

interface MetaSectionProps {
  item: CatalogItem;
  defaultOpen?: boolean;
}

const MetaSection: React.FC<MetaSectionProps> = ({ item, defaultOpen = false }) => (
  <CardSection title="Служебное" defaultOpen={defaultOpen}>
    <div style={{ color: '#999', fontSize: 12 }}>
      <div>Norm Key: {item.norm_key}</div>
      {item.ai_enriched && (
        <div>
          AI: уверенность {item.ai_confidence ? `${Math.round(item.ai_confidence * 100)}%` : 'н/д'}
        </div>
      )}
      {item.created_at && <div>Создан: {new Date(item.created_at).toLocaleDateString('ru')}</div>}
      {item.updated_at && <div>Обновлён: {new Date(item.updated_at).toLocaleDateString('ru')}</div>}
    </div>
  </CardSection>
);

export default MetaSection;
